import React from "react";
import { Col, Row } from "react-bootstrap";

import { ZeroCostProgramTypes } from "types";
import { floatWithComma2Normalizer } from "validators";

import TextBlock from "../components/textBlock";

type ZeroCostViewProps = {
	softwareOptionDefaults?: { [key: string]: any };
};

const ZeroCostView = ({ softwareOptionDefaults }: ZeroCostViewProps) => {
	const programType = parseInt(
		softwareOptionDefaults?.zero_cost_program_type,
	);

	return (
		<>
			<Row>
				<Col xl={3}>
					<TextBlock
						iconCheck
						value={ZeroCostProgramTypes.getDisplayName(programType)}
						dataAutotest="zeroCostProgramType"
					/>
				</Col>
				{programType !== ZeroCostProgramTypes.None.value && (
					<Col xl={3}>
						<TextBlock
							label="Zero Cost Processing"
							value={floatWithComma2Normalizer(
								softwareOptionDefaults?.zero_cost_amount || 0,
								"",
								"%",
							)}
							dataAutotest="zeroCostAmount"
						/>
					</Col>
				)}
			</Row>
		</>
	);
};

export default ZeroCostView;
